module.exports = __webpack_public_path__ + "img/screen.324c695d.png";